import { CatalogProductWithInventory } from "@redotech/marketplace-sdk/rpc/schema/get-marketplace-products";
import {
  CatalogProduct,
  CatalogVariant,
} from "@redotech/redo-marketplace-common/catalog-product-types";
import {
  MarketplaceCartItem,
  MarketplaceCartItemWithProduct,
} from "@redotech/redo-marketplace-common/marketplace-cart";
import { createContext } from "react";

export interface CartItem extends MarketplaceCartItem {
  product: CatalogProduct;
  variant: CatalogVariant;
}

export interface CartContextType {
  items: readonly MarketplaceCartItemWithProduct[];
  totalItems: number;
  totalPrice: number;
  isLoading?: boolean;
  cartId?: string;
  addItem: (
    product: CatalogProductWithInventory,
    variant: CatalogVariant,
    quantity?: number,
  ) => Promise<void>;
  removeItem: (productId: string, variantId: string) => Promise<void>;
  updateQuantity: (
    productId: string,
    variantId: string,
    quantity: number,
  ) => Promise<void>;
  clearCart: () => Promise<void>;
  refreshCart: () => void;
  getItem: (
    productId: string,
    variantId: string,
  ) => MarketplaceCartItem | undefined;
  isItemUpdating: (productId: string, variantId: string) => boolean;
  getItemError: (productId: string, variantId: string) => string | undefined;
  clearItemError: (productId: string, variantId: string) => void;
}

export const CartContext = createContext<CartContextType | undefined>(
  undefined,
);
